/** Filter sheet UI config — uses canonical taxonomy from profileTaxonomy.js */

import {
  DEFAULT_EXPANDED_SERVICE_SECTIONS,
  PROFILE_CATEGORIES,
  SERVICE_FOR_OPTIONS,
  SERVICE_OPTIONS,
  SERVICE_SECTIONS,
} from "./profileTaxonomy";

export {
  DEFAULT_EXPANDED_SERVICE_SECTIONS,
  PROFILE_CATEGORIES,
  SERVICE_FOR_OPTIONS,
  SERVICE_OPTIONS,
  SERVICE_SECTIONS,
};

export const FILTER_TABS = [
  { id: "region", label: "Region" },
  { id: "category", label: "Category" },
  { id: "services", label: "Angebot" },
];

export const DISTANCE_OPTIONS = [15, 50, 100];

/** @deprecated Use PROFILE_CATEGORIES from profileTaxonomy.js */
export const CATEGORY_OPTIONS = PROFILE_CATEGORIES;

export const DEFAULT_PROFILE_FILTERS = {
  nearby: false,
  nearbyKm: 15,
  cities: [],
  distanceKm: 15,
  categories: [],
  services: [],
};

/** Migrate legacy single `city` string to `cities` array. */
export function normalizeProfileFilters(filters = {}) {
  const normalized = {
    ...DEFAULT_PROFILE_FILTERS,
    ...filters,
    categories: Array.isArray(filters.categories) ? filters.categories : [],
    services: Array.isArray(filters.services) ? filters.services : [],
    cities: Array.isArray(filters.cities) ? [...filters.cities] : [],
  };

  if (filters.city && normalized.cities.length === 0) {
    normalized.cities = [filters.city];
  }

  delete normalized.city;
  delete normalized.regions;
  return normalized;
}

export function countActiveFilters(filters) {
  const normalized = normalizeProfileFilters(filters);
  let n = 0;
  if (normalized.nearby) n += 1;
  if (normalized.cities.length) n += normalized.cities.length;
  if (normalized.categories.length) n += normalized.categories.length;
  if (normalized.services.length) n += normalized.services.length;
  return n;
}

export function resetProfileFilters() {
  return { ...DEFAULT_PROFILE_FILTERS };
}
